import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes } from '@shared/helpers';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: true,
    imports: [ButtonModule, TranslateModule, NgOptimizedImage],
})
export class ErrorPageComponent {
    constructor(private router: Router) {}

    goToDashboard(): void {
        if (this.router.url.toLowerCase().indexOf(AppRoutes.routes().DASHBOARD) > -1) {
            this.router.navigate([AppRoutes.routes().DASHBOARD]).then(() => {
                window.location.reload();
            });
        } else {
            this.router.navigate([AppRoutes.routes().DASHBOARD]);
        }
    }

    openChat(): void {
        // @ts-ignore
        window['happyFoxChat'].showWidget();
        // @ts-ignore
        window['happyFoxChat'].expandChatbox();
    }
}
